<template>
  <div class="wrapper">
    <div class="animated fadeIn">
      <b-row>
        <b-col cols="12">
            <b-card header="<i class='fa fa-star'></i> Pembayaran Dashboard">
                <div id="myMap">
                
                </div>   
            </b-card>
        </b-col><!--/.col-->
      </b-row><!--/.row-->
    </div>
  </div>
</template>

<script>
import router from '@/router/index'
import axios from 'axios'
import {getCache,storedCache} from '@/cache'
import constant from '../../utils/constant.js';
export default {
  data () {
    return {
        isLoading: true,
        isModalVisible: false,
        selected : null,
        poskos:[],
        center: {
            lat : 9.0101,
            lng : -12.0101
        },
        maps : [],
        btnDonate: [],
        marker : [],
        markerPosko: [],
        infoWindow : []
    }
  },
  mounted() {
        this.initMap()   
        this.getCurrentLocation() 
  },
  created(){
     this.getPosko()
  },
  beforeMount()
  {
    // this.initMap()
  },
  watch: {
    '$route' : 'getpayments'
  },
  methods:{
      initMap()
      {
        this.maps = new google.maps.Map(document.getElementById('myMap'), {
            center: {lat : 39.305, lng: -76.617},
            scrollwheel: false,
            zoom: 10
        })
        this.infoWindow = new google.maps.InfoWindow();
        
      },
      getCurrentLocation()
      {
            navigator.geolocation.getCurrentPosition(position => {
                this.center = {
                    lat: position.coords.latitude,
                    lng: position.coords.longitude
                    };
                    this.infoWindow.setPosition(this.center);
                    this.maps.setCenter(this.center);

                    this.marker = new google.maps.Marker({
                        position: this.center,
                        title:"Hello World!"
                    });

                    this.marker.setMap(this.maps)
            });
          
          
        //   console.log(this.maps)
      },
      openSpinner()
      {
        this.isLoading = true
      },
      closeSpinner()
      {
        this.isLoading = false
      },
      confirm(id)
      {
        const token = localStorage.getItem(`user_token`);
        const community_id = localStorage.getItem('user_id');
        this.$swal({
          title: 'Konfirmasi ',
          text: 'Apakah anda yakin konfimasi pembayaran ini ?',
          type: 'error',
          showCancelButton: true,
          confirmButtonText: 'Yes Confirm!',
          cancelButtonText: 'No, Cancel!',
          showCloseButton: true,
          showLoaderOnConfirm: true
        }).then((result) => {
          if(result.value) {
              axios.put(constant._BASE_URL+"payment/"+id,"",{
                headers:{
                    'Content-type': 'application/json',
                    'Authorization' : 'Bearer '+token,
                }
              }).then(response => {
                    let message = response.data.success
                    console.log(message)
                    this.$swal('Konfirmasi', message , 'success')
                    this.getPayments()
              })
          } else {
    
          }
        })
      },
      getPosko()
      {
        var icon = {
            url:"https://image.flaticon.com/icons/png/128/1119/1119071.png", // url
            scaledSize: new google.maps.Size(40, 40), // scaled size
            origin: new google.maps.Point(0,0), // origin
            anchor: new google.maps.Point(0, 0) // anchor
        };
        
        const token = localStorage.getItem(`user_token`);
        const community_id = localStorage.getItem('user_id');
        axios.get(constant._BASE_URL+"posko",{
            headers:{
                'Content-type': 'application/json',
                'Authorization' : 'Bearer '+token,
            }
        }).then(response =>{
            storedCache(`poskos`+community_id, response.data)
            this.poskos = getCache(`poskos`+community_id)
            let markers = this.markerPosko
            var posko = response.data
            var infowindow = new google.maps.InfoWindow()
            for(let i=0;i<this.poskos.length;i++)
            {
                markers = new google.maps.Marker({
                position: new google.maps.LatLng(this.poskos[i]['lat'], this.poskos[i]['lng']),
                map: this.maps,
                icon : icon
              });
              google.maps.event.addListener(markers, 'click', (function(markers, i) {
                return function() {
                var contentString = 
                '<div>'+
                  '<img class="card-img-top" style="width:80px" src="'+'https://hackathon.futnet.id/posko/'+posko[i]['foto']+'" alt="Card image cap">'+
                  '<div class="card-body">'+
                    '<h5 class="card-title">'+posko[i]['user_name']+'</h5>'+
                    '<p class="card-text">'+posko[i]['deskripsi']+'</p>'+
                    '<a href="#/posko/'+posko[i]['id']+'" data-id="'+posko[i]['id']+'" id="btn-donate" class="btn-donate btn btn-primary">Donate</a>'+
                  '</div>'
                '</div>';
                  infowindow.setContent(contentString);
                  infowindow.open(this.maps, markers);
                }
              })(markers, i));
            }
            
        }).catch(error => {
            console.log(error)
            this.poskos = getCache(`poskos`+community_id)
            this.closeSpinner()
        });
      },
      initBtnDonasi: function()
      {
          // var btnDonate = document.getElementById('btn-donate')
          // console.log(btnDonate)
          // btnDonate.addListener('click',function(e){
          //   e.preventDefault
            alert('wlwkwk')
          // })
      },
      showModal() {
        this.isModalVisible = true;
      },
      closeModal() {
        this.isModalVisible = false;
      },
  }
}
</script>
<style scoped>
.imageFile {
  height: 150px;
}
.imageHome {
  width: 30%;
  display: inline-block;
  margin-left: 0dp;
  margin-right: 0dp;
}
#myMap {
    height:400px;
    width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/penyaluran/Penyaluran.vue